var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMn9Vyk13Qmmfwbe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2372_21415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9288 20.243L20.2118 17.381C19.4188 16.06 18.9998 14.547 18.9998 13.007V10.5C18.9998 7.335 16.8878 4.65802 13.9998 3.795V2.00002C13.9998 0.897 13.1028 0 11.9998 0C10.8967 0 9.99975 0.897 9.99975 2.00002V3.795C7.11178 4.65802 4.99978 7.335 4.99978 10.5V13.007C4.99978 14.547 4.58076 16.059 3.78876 17.38L2.07178 20.242C1.97878 20.397 1.97676 20.589 2.06578 20.746C2.15479 20.903 2.31979 21 2.49979 21H21.4998C21.6798 21 21.8458 20.9031 21.9348 20.7471C22.0238 20.591 22.0208 20.397 21.9288 20.243Z",
    fill: "#516F93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.85059 22C9.41459 23.178 10.6086 24 11.9996 24C13.3905 24 14.5846 23.178 15.1486 22H8.85059Z",
    fill: "#516F93"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2372_21415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMn9Vyk13Qmmfwbe);
export default __webpack_public_path__ + "static/media/mn9vyk13-qmmfwbe.13d81900babed3709d21a0e0a02f8c6b.svg";
export { ForwardRef as ReactComponent };